import { sva } from "@agapi/ui/panda/css";

export  const blogCardStyles = sva({
  slots: ['root', 'header', 'meta', 'title', 'content', 'description', 'footer', 'link', 'badge'],
  base: {
    root: {
      height: '100%',
      border: '1px solid token(colors.borders.subdued)',
      transition: 'box-shadow 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94), scale 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
      _hover: {
        boxShadow: '4px 4px 24px -12px rgba(0, 0, 0, 0.3)',
        scale: '1.02'
      }
    },
    header: {
      gap: '3!',
      pb: '2'
    },
    meta: {
      color: 'text.subdued',
      fontSize: 'xs',
      display: 'flex',
      gap: '2'
    },
    title: {
      textStyle: 'h6',
      color: 'text.heading'
    },
    content: {
      py: '1',
      px: 'var(--contentPadding)',
      flex: 1
    },
    description: {
      lineClamp: 3,
      textStyle: 'body',
      fontSize: 'sm'
    },
    badge: {
      mb: '2'
    }
  }
});